import { createRouter, createWebHistory } from 'vue-router';
import Error from "../pages/Error.vue"
import CPGChat from "../pages/CPG/CPGChat.vue"

const routes = [
  {
    path: '/',
    name: 'cpg-chat',
    component: CPGChat,
    meta: { requiresAuth: true }
  },


  {
    path: '/:catchAll(.*)*',
    name: 'error',
    component: Error, // Catch-all route for 404 or unauthorized access
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
